<template>
  <span />
</template>
<script>
import eventBus, { eventType } from '@g/utils/eventBus'

export default {
  name: 'DocEvent',
  created () {
    this.bind()
  },
  activated () {
    this.unbind()
    this.bind()
  },
  destroyed () {
    this.unbind()
  },
  deactivated () {
    this.unbind()
  },
  methods: {
    bind () {
      Object.keys(eventType).forEach((key) => {
        const methodName = `on${key}`
        this[methodName] = (e) => {
          this.$emit(methodName, e)
        }
        eventBus.$on(eventType[key], this[methodName])
      })
    },
    unbind () {
      Object.keys(eventType).forEach((key) => {
        const methodName = `on${key}`
        eventBus.$off(eventType[key], this[methodName])
      })
    },
  }
}
</script>
